import { useState, useEffect } from 'react';

/* Reads a CSS media query from JS and re-renders when it flips, so behaviour
   that only makes sense at one size (a tap target that exists because the
   layout hid a label, say) can be gated on the same breakpoint the stylesheet
   uses instead of a second, drifting definition of "mobile". */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    /* The query can have changed between the initial state and this effect
       (a prop-driven breakpoint), so sync once before subscribing. */
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
